const DEFAULT_GAME_SLUGS = ['popular', 'bonus', 'popular-lotto', 'pp-lg'];

export const getGameSlugs = (vendors = []) => [
  ...new Set([
    ...DEFAULT_GAME_SLUGS,
    ...vendors.filter(Boolean),
  ]),
];
